
<div class="uni-publication-card" [class.featured]="featured">
  <uni-publication-card-header
    [publication]="publication"
    [self]="self"
    (edit)="openContentPage($event)"
    (delete)="deletePublication($event)"
    [showCardOptions]="showCardOptions">
  </uni-publication-card-header>
  <div class="fx-row">
    <div id="cover" class="rounded-border height-min margin-right-4">
      <uni-publication-card-image
        [publication]="publication"
        [hasImageBadge]="hasImageBadge"
        [host]="host"
        [self]="self"
        (openDialogEvent)="openDialog($event)"
        (openPublication)="openContentPage($event)">
      </uni-publication-card-image>
    </div>
    <div>
      <uni-publication-card-title
        [publication]="publication"
        [showTimestamp]="showTimestamp"
        [self]="self"
        [host]="host"
        (openDialogEvent)="openDialog($event)"
        (openPublication)="openContentPage($event)">
      </uni-publication-card-title>
      <ng-container *ngIf="featured">
        <uni-publication-card-subtitle
          [publication]="publication">
        </uni-publication-card-subtitle>
      </ng-container>
      <uni-publication-card-footer
        [publication]="publication">
      </uni-publication-card-footer>
    </div>
  </div>
</div>
